/**
 * Branding constants — single source of truth for all client-facing text and assets.
 *
 * SAAS MIGRATION NOTE:
 * This file exists as a transitional step. Once multi-tenancy is in place,
 * these values will come from the organization's settings in the database.
 * Until then, changing branding requires only editing this file.
 */

export const APP_BRAND = {
  /** Product / company name shown in UI chrome */
  name: 'ZeroSuite',
  /** Tagline for login / public pages */
  tagline: 'CRM & Operations Suite',
  /** Path to logo asset (relative to /public) */
  logoPath: '/logo-ceroideas.png',
  /** Alt text for logo images */
  logoAlt: 'ZeroSuite Logo',
  /** Copyright holder */
  copyright: `© ${new Date().getFullYear()} ZeroSuite. Todos los derechos reservados.`,
  /** Support / noreply email */
  supportEmail: 'soporte@zerosuite.work',
  noreplyEmail: 'noreply@zerosuite.work',
  /** External links */
  links: {
    website: 'https://zerosuite.work',
    contact: 'https://zerosuite.work',
  },
} as const;

export type AppBrand = typeof APP_BRAND;
